import { Container } from '@material-ui/core';
import CreateInvoice from '../components/invoice/CreateInvoice';
import Page from '../components/Page';

export default function Client() {
  return (
    <Page title="Dashboard: Client | ZIMTA">
      <Container>
        <CreateInvoice />
      </Container>
    </Page>
  );
}
